// extracted by mini-css-extract-plugin
export default {"card":"CustomOverlayPanel_card__-KIaN"};